import SchoolsListLayer from "../../components/SchoolsListLayer";

const SchoolPage = () => {
  return <SchoolsListLayer />;
};

export default SchoolPage;
